import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ClickOutsideModule } from 'ng-click-outside';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { TakeOverModule } from '../../Common/TakeOver/take-over.module';
import { AccountPreferencesComponent } from './components/AccountPreferences/account-preferences.component';
import { AccountPreferencesService } from './services/account-preferences.service';
import { MonitoringAccountPreferencesComponent } from './components/MonitoringPreferences/monitoring-account-preferences.component';
import { ProminenceTakeOverPanelComponent } from './components/ProminenceTakeOverPanel/prominence-take-over-panel.component';

@NgModule({
    imports: [
        LocalizationModule,
        TabsModule,
        CommonModule,
        FormsModule,
        ButtonModule,
        MiscModule,
        ClickOutsideModule,
        CommonFormsModule,
        LayoutModule,
        AutoCompleteModule,
        SelectModule,
        InputTextModule,
        CheckboxModule,
        CommonBasicModule,
        TooltipModule,
        CoreDialogsModule,
        TakeOverModule
    ],
    declarations: [
        AccountPreferencesComponent,
        MonitoringAccountPreferencesComponent,
        ProminenceTakeOverPanelComponent
    ],
    exports: [
        AccountPreferencesComponent,
        ProminenceTakeOverPanelComponent
    ],
    providers: [
        AccountPreferencesService
    ]
})
export class AccountPreferencesModule { }
